<template>
  <div v-if="dialogPrint" style="display: none"></div>
</template>
<script>
import { getLodop } from "@/plugins/data/LodopFuncs";
import {
  PRINT_SCENES,
  resolvePrintTemplate,
} from "@/unit/printTemplateStorage.js";
import { renderAnnexNative, mapStoreWashPayload, resolveStoreWashGrillObj } from "@/unit/printLodopNative.js";

export default {
  props: {
    parentAnnex: {
      type: Object,
      default: () => ({}),
    },
    printBy: {
      type: String,
      default: "",
    },
    isPrint: {
      type: Boolean,
      default: false,
    },
    grillObj: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      printName: this.printBy,
      annexData: this.parentAnnex,
      dialogPrint: this.isPrint,
      grillObjs: this.grillObj,
      time: `${new Date().getMonth() + 1}/${new Date().getDate()}`,
    };
  },
  watch: {
    parentAnnex(newVal) {
      this.annexData = newVal;
    },
    printBy(newVal) {
      this.printName = newVal;
    },
    isPrint(newVal) {
      this.dialogPrint = newVal;
    },
    grillObj(newVal) {
      this.grillObjs = newVal;
    },
  },
  mounted() {
    this.$emit("child-annex", this.parentAnnex);
  },
  methods: {
    getTemplate() {
      return resolvePrintTemplate(PRINT_SCENES.STORE_WASH);
    },
    printAnnex(printData) {
      if (printData) {
        this.annexData = printData;
      }
      const annexData = printData || this.annexData;
      const ann = annexData.annexCode || [];
      if (!ann.length || !this.printName) {
        return;
      }
      const LODOP = getLodop();
      if (!LODOP) {
        return;
      }
      const tpl = this.getTemplate();
      const data = { ...annexData, time: this.time };
      const basePayload = mapStoreWashPayload(
        data,
        tpl,
        resolveStoreWashGrillObj(data, this.grillObjs),
      );
      LODOP.PRINT_INIT("附水洗码" + annexData.washingCode);
      ann.forEach((code, index) => {
        if (index > 0) {
          LODOP.NEWPAGE();
        }
        let annexProduct = "";
        const arr = annexData.productAnnex;
        if (arr) {
          const list = Array.isArray(arr) ? arr : String(arr).split(",");
          annexProduct = list[index] || "";
        }
        renderAnnexNative(LODOP, tpl, basePayload, {
          code,
          printName: this.printName,
          annexProduct,
          scene: PRINT_SCENES.STORE_WASH,
        });
      });
      LODOP.PRINT();
    },
  },
};
</script>
